var map = {
	"./amazon.svg": 96244,
	"./apple.svg": 19452,
	"./checkmark.svg": 24958,
	"./close.svg": 26771,
	"./copy.svg": 53874,
	"./devcommunity.svg": 83981,
	"./discord.svg": 27803,
	"./dropdown.svg": 10485,
	"./facebook.svg": 67158,
	"./github.svg": 71222,
	"./google.svg": 40537,
	"./linkedin.svg": 50927,
	"./linux.svg": 61284,
	"./love.svg": 6251,
	"./medium.svg": 3418,
	"./menu.svg": 83810,
	"./microsoft.svg": 25481,
	"./product-of-the-day.svg": 38881,
	"./producthunt.svg": 28228,
	"./reddit.svg": 18256,
	"./reload.svg": 28699,
	"./right-arrow-circle.svg": 13393,
	"./rightarrow.svg": 52615,
	"./run.svg": 14485,
	"./search.svg": 78781,
	"./spinner.svg": 6372,
	"./spotify.svg": 33082,
	"./twitter.svg": 46551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44447;